/**
 * User-readable text of a caught error. `String(err)` would show
 * "ApiError: …"; an ApiError's `message` already is the server's German
 * text (see `toApiError` in api.ts).
 */
export function errorText(err: unknown): string {
  if (err instanceof Error) return err.message;
  return typeof err === 'string' ? err : 'Unbekannter Fehler. Bitte versuche es erneut.';
}
